
export const ORG_GOALS_PROGRAM = 'NkReudUAW4F';
export const ORG_GOALS_STAGE = 'VomTWbJot7U';
export const ORG_GOALS_LINKAGE_STAGE = 'IEsUtu84bQU'; 

export const DATA_ELEMENTS = {
  NAME: 'HJqqfzhH614', 
  DESCRIPTION: 'zS8QIgZc0Ll', 
  PROGRESS: 'pOOGDRzEo98', 
  START_DATE: 'MH7DQVegD1j', 
  END_DATE: 'pUvJQ9vy3A3', 
  STATUS: 'H5I924FiijC', 
  PRIORITY: 'Co2i5BleCcZ', 
  CATEGORY: 'uBPW95V2VoX',
  CREATED_BY: 'ir4nG6zZn4w' 
};


export const ROLES = {
  ADMIN: "R3lFolCMdoi",
  CEO: "nLSSLch316I",
  HOD: "adeqQmxfCLF",
  TOP_STAFF: "gtMJNK0QVL7",
  SENIOR_STAFF: "vdVjNaqxblC",
  GUEST: "Guest"
};

export const GOALS_QUERY = {
  goals: {
    resource: 'events',
    params: {
      program: ORG_GOALS_PROGRAM, // Use separate program
      programStage: ORG_GOALS_STAGE,
      fields: 'event,orgUnit,eventDate,createdAt,updatedAt,dataValues[dataElement,value]',
      totalPages: true,
      pageSize: 1000
    }
  }
};

// Add these constants to your GoalsConstants or in the component
export const OBJECTIVE_DATA_ELEMENTS = {
  NAME: 'EuN5ztFnXsQ',
  DESCRIPTION: 'nWqW5BrcgP1',
  STATUS: 'DL7KxNhiV0x',
  START_DATE: 'eDcVy661j9e',
  COMPLETION_DATE: 'J0rjxrDKn1l',
  WEIGHT: 'yfb9RCRpMB2',
  BASELINE: 'WvfEOREFo9l',
  SCORE: 'LEEqJmI9Lyi',
  REMARKS: 'KeGWxm1IDYF',
  ALIGNMENT: 'VhrIQQIVpB9', // Objective Alignment with Company Goals
  APPROVAL_STATUS: 'DzQorireRBf',
  APPROVED_BY: 'owgP6wkRUwU'
};


// Helper function to extract value from dataValues array
export const getDataValue = (dataValues, dataElementId) => {
    const dataValue = dataValues.find(dv => dv.dataElement === dataElementId);
    return dataValue ? dataValue.value : '';
};